import Vue from 'vue';
import StarRating from 'vue-star-rating';
import Slick from 'vue-slick';
import modal from './components/generals/modal.vue';
import multiselect from 'vue-multiselect';
import loading from './components/generals/loading.vue';
import VueYoutube from "vue-youtube";

import "vue-multiselect/dist/vue-multiselect.min.css";

Vue.component('star-rating', StarRating);
Vue.component('vue-slick', Slick);
Vue.component('general-modal', modal);
Vue.component('multiselect', multiselect);
Vue.component('loading', loading);
Vue.use(VueYoutube);
